import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import CustomDropdownBorderNormalize from "@/components/CustomDropdownBorderNormalize/CustomDropdownBorderNormalize.vue";
import CustomInput from "@/components/CustomInput/CustomInput.vue";
import Preloader from "@/components/Preloader/Preloader.vue"
import PhoneMaskInput from "vue-phone-mask-input";
import InfoMessage from "@/components/AlertMessage/InfoMessage.vue";
import TicketCard from "../../components/TicketCard/TicketCard.vue";
import SupportUploadFile from "../../components/SupportUploadFile/SupportUploadFile.vue";
import UploadFilesMultipart from "../../components/UploadFilesMultipart/UploadFilesMultipart.vue";
import VueRecaptcha from "vue-recaptcha";
import Pagination from "../../components/__new_ui_kit/Pagination/Pagination.vue";
import axios from 'axios'
import NoAuthForm from "@/views/Support/NoAuthForm";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "Support",
    components: {
        CustomDropdownBorder,
        CustomInput,
        CustomDropdownBorderNormalize,
        Preloader,
        PhoneMaskInput,
        InfoMessage,
        TicketCard,
        SupportUploadFile,
        UploadFilesMultipart,
        VueRecaptcha,
        Pagination,
        NoAuthForm
    },
    data() {
        return {
            inputs: 1,
            fileImg: null,
            file_arr: [],
            successShip: false,
            selectedOption: null,
            selectedTopic: null,
            department:'',
            topic:'',
            message:'',
            ticketArray:[],
            date:'',
            contactPhone:'',
            contactMail:'',
            contactName: '',
            messageError: false,
            messageErrorTopic: false,
            showPreloader: true,
            messageErrorContact: false,
            messageErrorContactName: false,
            phoneUnregister: '',
            test_input: '',
            numberOfFiles: 0,
            namesFiles: [],
            testImageFiles:[],
            sizeEnable: 5,
            fileSizes: 0,
            limitNumberFiles: 10,
            create_ticket_id: 'create_ticket',
            isDisabledBtn: false,
            isEnabledRecaptcha: eval(process.env.VUE_APP_RECAPTCHA_ENABLED),
            sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN,
            grecaptcha: '',
        }
    },
    methods: {
        ...mapActions(['get_all_tickets', 'resetError']),
        changePage(page) {
          this.get_all_tickets(page).then(() => {})
        },
        disabledSendForm() {
            document.getElementById('create_ticket').click();
            return false;
        },
        success() {
          this.successShip = true
        },
        getFiles(data) {
            this.file_arr = data;
        },
        inputContactMail(data) {
            if (data.inp.trim().length > 0) {
                this.messageErrorContact = false
            }
            this.contactMail = data
        },
        inputContactName(data) {
            if (data.inp.trim().length > 0) {
                this.messageErrorContactName = false
            }
            this.contactName = data
        },
        methodToRunOnSelect(payload) {
            this.selectedOption = payload;
            this.department = payload;
        },
        clickHandler(event) {           // click outside the element
            const {target} = event;
            const {$el} = this;
            if (!$el.contains(target)) {
                this.messageError = false;
            }
        },
        submitTicket() {
            this.isDisabledBtn = true;
            this.$store.dispatch('resetError').then(() => {
                let d = new Date();
                this.date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + "T" + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
                this.$store.dispatch('resetError').then(() => {
                    const dataTicket = {
                        type: "tickets",
                        topic_id: Number(this.selectedTopic),
                        status: "created",
                        body: this.message,
                        internal_user_id: String(JSON.parse(localStorage.user).id),
                        user_id: this.id_dashboard,
                        webhook: '',
                        event_time: this.date,
                        files: this.sendImageArr
                    }
                    this.$store.dispatch('create_ticket', dataTicket)
                        .then(() => {
                            this.successShip = true;
                            this.file_arr = [];
                            this.namesFiles = [];
                            document.querySelector('#files').value = ""
                            this.isDisabledBtn = false;
                        }).catch(() => {
                        this.isDisabledBtn = false;
                        if (this.message.length === 0) {
                            this.messageError = true;
                        }
                    })
                })
            })
        },
        submitFeedback() {
            this.isDisabledBtn = true;
            this.$store.dispatch('resetError').then(() => {
                const dataFeedback = { //data for creating feedback
                    opinion: 1,
                    category_id: 2,
                    category_name: "general",
                    name: this.contactName.inp,
                    message: this.message,
                    email: this.contactMail.inp,
                    phone: this.phoneUnregister,
                    grecaptcha: this.grecaptcha,
                }

                this.$store.dispatch('create_feedback', dataFeedback)
                    .then((resp) => {
                        this.successShip = true;
                        this.isDisabledBtn = false;
                        this.messageErrorContact = false;
                        this.messageErrorContactName = false;
                        this.resetCaptchaToken()
                    })
                    .catch(error => {
                        if (this.message.length === 0) {
                            this.messageError = true;
                        }
                        if (this.contactMail.length === 0) {
                            this.messageErrorContact = true;
                        }
                        if (this.contactName.length === 0) {
                            this.messageErrorContactName = true;
                        }
                        if (error.response.status === 404) {
                            this.onCaptchaReset()
                        }
                        this.isDisabledBtn = false;
                    })
            })
        },
        refresh() {
            this.successShip = false
            this.message = ''
            this.contactMail = '';
            this.contactName = '';
            this.get_all_tickets().then((response) => {})
        },
        leaveTextarea() {
            if (this.message.length === 0) {
                this.messageError = true
            }
        },
        verify(recaptchaToken) {
            this.grecaptcha = recaptchaToken;
        },
        onCaptchaReset() {
            if (this.isEnabledRecaptcha) {
                this.$refs.recaptcha.reset()
                this.resetCaptchaToken()
            }
        },
        resetCaptchaToken() {
            localStorage.removeItem('_grecaptcha')
            this.grecaptcha = '';
        }
    },
    computed: {
        ...mapGetters([
            'isLoggedIn',
            'getError',
            'getAllTickets',
            'getTicketsCurrentPage',
            'getTicketsPagesTotal'
        ]),
        sendImageArr() {
            return this.file_arr
        }
    },
    watch: {
        message: function(val, oldVal) {
            if (this.message.length > 1000) {
                this.messageError = true
                this.message = oldVal
            } else {
                this.messageError = false
            }
        }
    },
    created() {
        this.$store.dispatch('resetError').then(() => {})
        if (this.isLoggedIn) {
            this.get_all_tickets(1).then((response) => {})
            this.$store.dispatch('get_ticket_topics')
                .then(response => {
                    this.info = response.data;
                    this.ticketArray = response.data;
                    if (this.ticketArray.data.length > 0) {
                        this.selectedTopic = this.ticketArray.data[0].id
                    }
                })
                .catch(error => {
                    console.log(error);
                    // this.messageError = true;
                })
                .finally(() => {
                    setTimeout(() => this.showPreloader = false, 500)
                });
        } else {
            setTimeout(() => this.showPreloader = false, 500)
        }
    },
}
